"use strict";
import ObjectWithIDStore from "../stores/object_with_id_store";
import CarrierService from "./carrier_service";
export const EmailService = function() {
  var store = new ObjectWithIDStore();
  return {
    _store: store,
    populatedAtLeastOnce: false,
    messages: store.items,
    updateFromData: function(data) {
      var ret;
      if (data.email_messages) {
        ret = _.map(data.email_messages, function(message) {
          return this._store.addOrUpdate(message);
        }.bind(this));
      } else if (data.email) {
        ret = [this._store.addOrUpdate(data.email)];
      } else if (data.summary_emails) {
        ret = this._store.addOrUpdateAll(data.summary_emails);
      } else {
        ret = [];
      }
      if (!_.isEmpty(ret)) {
        $(this).trigger("emailService:updated");
      }
      return ret;
    },
    documentMessages: function() {
      return _.where(this._activeItems(), { message_type: "documents" });
    },
    replyMessages: function() {
      return _.where(this._activeItems(), { message_type: "reply" });
    },
    pausedMessages: function() {
      return _.select(this.messages, this._paused);
    },
    markComplete: function(email, leave_exceptions_open, emailId, ignored = false) {
      const id = emailId || email.id;
      return $.post(
        "/api/email_messages/" + id + "/complete",
        { leave_exceptions_open, ignored }
      ).then(function(data) {
        this.updateFromData(data);
      }.bind(this));
    },
    _paused: function(e) {
      var now = /* @__PURE__ */ new Date();
      return e.paused_until && now < new Date(e.paused_until);
    },
    _completed: function(e) {
      return e.completed_at;
    },
    _activeItems: function() {
      return _.reject(_.reject(this.messages, this._paused), this._completed);
    },
    getWithId: function(id, force) {
      var existing = store.index[id];
      if (existing && !force) {
        return Promise.resolve(store.index[id]);
      } else {
        return this.fetchEmailWithID(id);
      }
    },
    activeAndPaused: function() {
      return Promise.resolve($.get(
        "/api/email_messages/active_and_paused",
        { since: this._lastUpdatedAt }
      )).then((data) => {
        var emails = this.updateFromData(data);
        if (data.carriers) {
          CarrierService.carrierService.updateCarriers(data.carriers);
        }
        var t = this._updatedFromEmails(emails);
        if (t) {
          this._lastUpdatedAt = t.getTime();
        }
        if (!_.isEmpty(emails)) this.populatedAtLeastOnce = true;
        return emails;
      });
    },
    fetchEmailWithID: function(id) {
      return Promise.resolve(
        $.get("/api/email_messages/" + id)
      ).then((data) => {
        this.updateFromData(data);
        return store.index[id];
      });
    },
    _updatedFromEmails: function(emails) {
      var datesFromEmails = _.map(emails, function(e) {
        return new Date(e.updated_at);
      });
      if (datesFromEmails.length > 0) {
        return _.max(datesFromEmails);
      }
      return /* @__PURE__ */ new Date(0);
    }
  };
};
export const emailService = new EmailService();
